import { useAppSelector } from '@redux/hooks';
import { selectCartList } from '@redux/slices/ProductManagement';
import { PartProduct, Part } from '@entities/Product';

export const useTireInCart = (): boolean => {
  const products = useAppSelector(selectCartList);

  return products.some(item => item.part === Part.Tyres || item.part === PartProduct.Tyres);
};
